import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { PREDICTION_KEY } from 'App/Map/PanelDetails/StackemCharts/_utils/by-domain/soil/_utils/predictionKey'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const soilVwc: typeof valueTypeRenderers.soilVwc = {
  label: () => unitConverter.soilVwc().titleWithoutUnit(),
  point: ({ metadata }) => {
    if (metadata.depth === PREDICTION_KEY) {
      return () => []
    }

    return makeNumberRenderer({
      metaId: metadata.depth,
      baseLabel: twoItemLabel([
        unitConverter.soilVwc().title(),
        unitConverter.soilDepth(Number(metadata.depth)).valueWithSuffix(),
      ]),
      render: (n) => unitConverter.soilVwc(n).valueAsString(),
    })
  },
}
